var map = {
	"./flag-en.png": 898,
	"./flag-lt.png": 899
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1260;



//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/flag\-.*\.png$
// module id = 1260
// module chunks = 0